import React from 'react';

import ApolloClientProvider from './ApolloClientProvider';
import Router from './Router';
import ErrorBoundary from './ErrorBoundary';
import MantineTheme from './MantineTheme';

const App: React.FC = () => (
  <MantineTheme>
    <ApolloClientProvider>
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
    </ApolloClientProvider>
  </MantineTheme>
);

export default App;
